import { Icon } from "@vitalsource/vstui";
import React from "react";

const Books = () => (
  <Icon width={41} height={51}>
    <g fill="none" fillRule="evenodd">
      <path
        d="M20.138 51H.862C.386 51 0 50.599 0 50.104V22.896C0 22.4.386 22 .862 22h19.276c.476 0 .862.401.862.896v27.208c0 .495-.386.896-.862.896"
        fill="#00A7DB"
      />
      <path
        d="M17.06 47H3.94c-.52 0-.94-.435-.94-.972V31.972c0-.537.42-.972.94-.972h13.12c.52 0 .94.435.94.972v14.056c0 .537-.42.972-.94.972M17.078 28H3.922A.922.922 0 0 1 3 27.079v-.158c0-.508.413-.921.922-.921h13.156c.509 0 .922.413.922.921v.158a.922.922 0 0 1-.922.921"
        fill="#75CFEC"
      />
      <path
        d="M39.931 44H18.069C17.48 44 17 43.535 17 42.96V12.04c0-.575.479-1.04 1.07-1.04H39.93c.59 0 1.069.465 1.069 1.04v30.92c0 .575-.478 1.04-1.069 1.04"
        fill="#FE9840"
      />
      <path
        d="M35.953 34H22.047C21.469 34 21 33.54 21 32.97V16.03c0-.569.469-1.03 1.047-1.03h13.906c.578 0 1.047.461 1.047 1.03v16.94c0 .57-.469 1.03-1.047 1.03M35.953 37H22.047c-.578 0-1.047.578-1.047 1.292v.416c0 .714.469 1.292 1.047 1.292h13.906c.578 0 1.047-.578 1.047-1.292v-.416c0-.714-.469-1.292-1.047-1.292"
        fill="#FEC391"
      />
      <path
        d="M29.024 29H8.976C8.436 29 8 28.53 8 27.952V1.048C8 .469 8.437 0 8.976 0h20.048c.54 0 .976.469.976 1.048v26.904c0 .579-.437 1.048-.976 1.048"
        fill="#23C991"
      />
      <path
        d="M24.992 16H13.008C12.451 16 12 15.55 12 14.997V5.003C12 4.449 12.451 4 13.008 4h11.984C25.549 4 26 4.449 26 5.003v9.994c0 .554-.451 1.003-1.008 1.003M25.096 26H12.904c-.499 0-.904-.448-.904-1s.405-1 .904-1h12.192c.5 0 .904.448.904 1s-.405 1-.904 1M24.992 23H13.008c-.557 0-1.008-.408-1.008-.912v-1.175c0-.504.451-.913 1.008-.913h11.984c.557 0 1.008.409 1.008.913v1.175c0 .504-.451.912-1.008.912"
        fill="#86E0C2"
      />
    </g>
  </Icon>
);

export default Books;
